/*
  A session that the server ended. An authenticated request (one that carried a credential) is answered 401 when the admin API no longer
  accepts the credential: an account that is not active, a token it refuses (legaleyse-backend#96, #105). The user is logged out, and the
  login page says why. The login's own 401 ("Invalid username/password") carries no credential, so it is not this.

  Imports nothing, so that RestTemplate can use it without a cycle through the store.
*/

export const sessionEndedMessage =
    'Your session has ended, or your account is not active. Log in again.';

/* Whether the error is the refusal of the credential a request was sent with: a 401 to a request that carried an Authorization header. */
export const isRefusalOfCredential = error =>
    !!error &&
    !!error.response &&
    error.response.status === 401 &&
    !!error.config &&
    !!error.config.headers &&
    !!error.config.headers.Authorization;
